import axios from '|/helpers/axios';

export type VehicleDetails = {
  header?: {
    vehicleId?: number;
    year?: number;
    make?: string | null;
    model?: string | null;
    trim?: string | null;
    mileage?: number;
    price?: number;
    vehicleImageUrlPackage: {
      smallImageUrl?: string | null;
      jellyBeanMobileUrl?: string | null;
    };
  };
  details?: {
    basics?: {
      vin?: string | null;
    };
  };
};

export const getVehicleData = (vehicleId: number) =>
  axios
    .get<VehicleDetails>(
      `${process.env.VEHICLE_DETAILS_API_URL}/api/v1/vehicledetails?vehicleId=${vehicleId}`
    )
    .then(res => res.data);

type SearchResult = {
  inventory?: { pagination?: { totalMatchedInventory?: number } };
};

export const getSearchResult = (payload: any) =>
  axios
    .post<SearchResult>(
      `${process.env.SEARCH_API_URL}/api/v2/search`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
    .then(res => res.data);

export const getPurchaseStatus = (abortSignal: AbortSignal, vehicleId?: number) =>
  axios
    .get<PurchaseStatus>(
      `${process.env.PURCHASE_API_URL}/api/v1/purchase-status${vehicleId ? `?vehicleId=${vehicleId.toString()}` : ''}`,
      { signal: abortSignal }
    )
    .then(res => res.data);

interface PurchaseStatus {
  mostRecentSaleDate: string;
  hasActivePurchase: boolean;
  isActivePurchaseReservedCart: boolean;
  activePurchaseVehicleId: number;
  isVehicleAvailable: boolean;
}

interface FundsVerification {
  accountNumberMask: string;
  completedDateTime: string;
  customerHasPlaid: boolean;
  fundsDeadlineUtc?: string;
  isCompleted: boolean;
  isRequired: boolean;
  plaidContainsAchAccount: boolean;
  plaidIdentityValidForFunds: boolean;
}

interface Verification {
  amountVerified: string;
  customerIsGreen: boolean;
  documentsVerificationIsComplete: boolean;
  driversLicenseIsValid: boolean;
  driversLicenseNotes: string;
  driversLicenseOutcome: string;
  employmentVerificationMethod: string;
  employmentVerificationOutcome: string;
  fundsVerification?: FundsVerification;
  identityVerificationCreditReportCheckOutcome: string;
  identityVerificationLexisNexusCheckOutcome: string;
  identityVerificationOutcome: string;
  lastModifiedDate: string;
  loanIsVerified: boolean;
  loanVerificationIsComplete: boolean;
  proofOfEmploymentIsRequired: boolean;
  proofOfIncomeIsRequired: boolean;
  proofOfResidenceIsRequired: boolean;
  residencyVerificationUnderwritingOutcome: string;
  rvvIsRequired: boolean;
  verificationDeadline: string;
}

export const fetchVerifications = () =>
  axios
    .get<Verification>(`${process.env.API_URL}/api/v1/verification`)
    .then(res => res.data);

export const switchVehicle = (newVehicleId: number, abortSignal: AbortSignal) =>
  axios
    .post(
      `${process.env.PURCHASE_API_URL}/api/v1/switch-vehicle/${newVehicleId}`,
      {},
      {
        signal: abortSignal
      }
    )
    .then(() => void 0);

export const startPurchase = (vehicleId: number, abortSignal: AbortSignal) =>
  axios
    .post<void>(
      `${process.env.PURCHASE_API_URL}/api/v1/start-purchase/${vehicleId}`,
      void 0,
      { signal: abortSignal }
    )
    .then(() => void 0);

type Cancellation = {
  reasons: string[];
  notes?: string;
  executeReturnVehicle?: boolean;
};

export const cancelPurchase = (cancellation: Cancellation) =>
  axios
    .post<Cancellation, void>(
      `${process.env.PURCHASE_API_URL}/api/v1/cancel`,
      cancellation
    )
    .then(() => void 0);
